import DropdownMenu from "../DropdownMenu"
import {isMobile} from "../../utils/deviceUtils"
import {shareViaWhatsapp} from "../../utils/interactionUtils"

export default ({
    phoneNumber="",
    whatsappMessage="Hi, ",
    whatsappLabel="Whatsapp",
    phoneLabel="Call"
}) => {
    if (!phoneNumber) return null
    const phoneNumberMenuItems = []
    phoneNumberMenuItems.push(
        {
            label: whatsappLabel,
            icon: "whatsapp",
            onClick: () => shareViaWhatsapp(whatsappMessage, phoneNumber)   
        }
    )
    if (isMobile()) phoneNumberMenuItems.push(
        {
            label: phoneLabel,
            icon: "phone",
            onClick: () => window.open(`tel:${phoneNumber}`)
        }
    )
    return <DropdownMenu 
                MenuIcon={<span className="a font-weight-600 margin-left-05em">{phoneNumber}</span>} 
                menuItems={phoneNumberMenuItems}
            />
}